module.exports = __webpack_public_path__ + "img/Group 1142813967.bbe3904d.png";